import { z } from 'zod';

// OTP認証フォームのバリデーションスキーマ
export const otpVerificationSchema = z.object({
  otp: z
    .string()
    .min(1, '認証コードは必須です')
    .length(6, '認証コードは6桁の数字で入力してください')
    .regex(/^\d{6}$/, '認証コードは6桁の数字で入力してください'),
});
